import React from "react";
import { Table, Tooltip } from "antd";
import editIcon from "../../../../Assets/svg/table-action-edit.svg";
import deleteIcon from "../../../../Assets/svg/table-action-delete.svg";
import FacilityTag from "../../../components/FacilityTag/FacilityTag";


const FacilitiesTable = ({
  data,
  loading,
  pagination,
  onPageChange,
  onEdit,
  onDelete,
  onPreview,
}) => {
  const columns = [
    {
      title: "Name of Facility",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Color",
      dataIndex: "color",
      key: "color",
      render: (color, record) => (
        <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
          <span
            style={{
              width: 18,
              height: 18,
              borderRadius: 4,
              background: color,
              border: "1px solid #eee",
              flexShrink: 0,
            }}
          />
          <FacilityTag facility={record} />
        </div>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      width: 150,
      render: (_, record) => (
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <Tooltip title="Edit">
            <img
              src={editIcon}
              style={{ cursor: "pointer" }}
              alt="editicon"
              onClick={() => onEdit(record)}
            />
          </Tooltip>
          <Tooltip title="Delete">
            <img
              src={deleteIcon}
              style={{ cursor: "pointer" }}
              alt="deleteicon"
              onClick={() => onDelete(record)}
            />
          </Tooltip>
        </div>
      ),
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      loading={loading}
      pagination={pagination}
      onChange={onPageChange}
      rowKey="id"
      className="mt-5"
    />
  );
};

export default FacilitiesTable;
